import { render, staticRenderFns } from "./Domit.vue?vue&type=template&id=82831baa&scoped=true&"
import script from "./Domit.vue?vue&type=script&lang=js&"
export * from "./Domit.vue?vue&type=script&lang=js&"
import style0 from "./Domit.vue?vue&type=style&index=0&id=82831baa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82831baa",
  null
  
)

export default component.exports